import PropTypes from 'prop-types';
import React, { memo } from 'react';
import styled from 'styled-components';

import RecurringAppointmentIcon from 'assets/v2/RecurringAppointmentIcon';
import { COLORS } from 'theme';

import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.myrtleGreenDark};
    background: ${COLORS.myrtleGreenLight};
    border-color: ${COLORS.myrtleGreen};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.myrtleGreenDark};
    }
  }
`;

const RecurringScheduleBadge = ({ label, ...props }) => (
  <StyledBadge
    label={label ?? 'Recurring schedule'}
    icon={<RecurringAppointmentIcon />}
    {...props}
  />
);

RecurringScheduleBadge.propTypes = {
  label: PropTypes.string,
};

export default memo(RecurringScheduleBadge);
